import {
  DiagnosticAgentType,
  PatientCase,
  useDiagnosticAgentType,
} from "../../../context/diagnosticAgent";
import { useDaoContext } from "fe-web-components/diseaseview/DaoContext";
import { usePatientCase } from "../usePatientCase";
import { useCallback } from "react";
import { WebDao } from "fe-common/graphql/dao";
import { getDiagnosticAgentConfiguration } from "../config/configurationTypes";
import { patientCaseGroupingForSave } from "../useStoredPatientCase";

export async function storeSharedCase(
  agentType: DiagnosticAgentType,
  patientCase: PatientCase,
  dao: WebDao,
) {
  const agentConfig = getDiagnosticAgentConfiguration(agentType);
  const consider = agentConfig.considerPanelIDs;
  const patientCaseId = await dao.storePatientCase(
    patientCaseGroupingForSave(patientCase),
    consider,
  );
  return patientCaseId;
}

export function useCreateSharedCase(propAgentType?: DiagnosticAgentType) {
  const dao = useDaoContext();
  const { patientCase } = usePatientCase();
  const [stateAgentType] = useDiagnosticAgentType();
  const agentType = propAgentType || stateAgentType;
  return useCallback(() => storeSharedCase(agentType, patientCase, dao), [
    dao,
    patientCase,
    agentType,
  ]);
}
